import { Input, Select } from 'antd'
import React from 'react'
import { filterJobList, statusList } from './Modal/TRFHelper'

interface FunctionProps {
  [key: string]: any;
}
const TRFFilter = (props: FunctionProps) => {
  const { searchQuery, setSearchQuery, handleClear, handleSubmit } = props;
  return (
    <div className="flex justify-between px-4">
      <div className="grid grid-cols-7 gap-2 mb-6">
        <div>
          <p className="text-[#D34A7C] font-bold">Name</p>
          <Input placeholder="Name" value={searchQuery?.createdByName} onChange={(e) => setSearchQuery({ ...searchQuery, createdByName: e.target.value })} />
        </div>
        <div>
          <p className="text-[#D34A7C] font-bold">Designation name</p>
          <Input placeholder="Designation name" value={searchQuery?.designationName} onChange={(e) => setSearchQuery({ ...searchQuery, designationName: e.target.value })} />
        </div>
        <div>
          <p className="text-[#D34A7C] font-bold">Job type</p>
          <Select
            className="w-full"
            options={filterJobList}
            placeholder="Job Type"
            value={filterJobList?.filter((item: any) => item?.value === searchQuery?.jobType)}
            onChange={(value: any) => setSearchQuery({ ...searchQuery, jobType: value })}
          ></Select>
        </div>
        <div>
          <p className="text-[#D34A7C] font-bold">Status</p>
          <Select
            className="w-full"
            options={statusList}
            placeholder="Status"
            value={statusList?.filter((item: any) => item?.value === searchQuery?.status)}
            onChange={(value: any) => setSearchQuery({ ...searchQuery, status: value })}
          ></Select>
        </div>
        <div className="flex items-center pt-3 pl-8">
          <div className="mr-2">
            <button type="button" className="secondary clear-filter h-[40px]" onClick={handleClear}>
              Clear filter
            </button>
          </div>
          <div>
            <button type="submit" className="addButton  primary pr-1 " onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TRFFilter